import { ComponentType } from 'react';
import {
  DropdownMenuSub,
  DropdownMenuSubTrigger,
  DropdownMenuPortal,
  DropdownMenuSubContent,
  DropdownMenuLabel,
  DropdownMenuItem,
} from '@c2fo/liquidity';
import { CheckIcon } from '@c2fo/liquidity/icons';

export interface SubmenuItem {
  name: string;
  label: string;
  onClick: () => void;
}

interface SubmenuDropdownItemProps {
  icon: ComponentType<{ className?: string }>;
  title: string;
  subtitle?: string;
  items: SubmenuItem[];
  selectedValue: string;
  width?: string;
}

const SubmenuDropdownItem = ({
  icon: Icon,
  title,
  items,
  selectedValue,
  subtitle,
  width = 'w-48',
}: SubmenuDropdownItemProps) => (
  <DropdownMenuSub>
    <DropdownMenuSubTrigger>
      <div className="flex items-center gap-2">
        <Icon className="size-6 shrink-0 fill-text-secondary" />
        {title}
      </div>
    </DropdownMenuSubTrigger>
    <DropdownMenuPortal>
      <DropdownMenuSubContent className={width}>
        <DropdownMenuLabel>{title}</DropdownMenuLabel>
        {subtitle && <div className="px-5 pb-2 text-sm text-text-secondary">{subtitle}</div>}
        {items.map((item) => (
          <DropdownMenuItem key={item.name} onClick={item.onClick} selected={selectedValue === item.label}>
            <div className="flex w-full items-center justify-between gap-2">
              {item.label}
              {selectedValue === item.label && <CheckIcon className="size-6 fill-text-secondary/50" />}
            </div>
          </DropdownMenuItem>
        ))}
      </DropdownMenuSubContent>
    </DropdownMenuPortal>
  </DropdownMenuSub>
);

export default SubmenuDropdownItem;
